import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlBensImoveis = '/service/materiais/patrimonio/bem/'

class ConsultaBensImoveisService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms ? config.adms : []
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value) : this.state.adms,
            classificacao: filtro.classificacao ? filtro.classificacao.map(e => e.value) : '',
            codigoSituacaoLegal: filtro.codigoSituacaoLegal ? filtro.codigoSituacaoLegal.map(e => e.value) : '',
            identificacao: filtro.identificacao,
            endereco: filtro.endereco,
        }

        return this.conex.post(urlBensImoveis + 'consultaBensImoveis/', JSON.stringify(data))
    }
}

export default ConsultaBensImoveisService
